import { render, staticRenderFns } from "./ThemeLooperTile.vue?vue&type=template&id=70b22c1c"
import script from "./ThemeLooperTile.vue?vue&type=script&lang=ts"
export * from "./ThemeLooperTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports